export default {"src":"/_next/static/image/src/assets/close-white.7fb4892fd6c986a79835f67d6e88a5c1.svg","height":24,"width":24};